/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AuthResponse {
  /**
  * A valid access token that Amazon Cognito issued to the user who you want to authenticate
  */
  'accessToken'?: string | null;
  /**
  * The expiration period of the authentication result in seconds.
  */
  'expiresIn'?: number;
  /**
  * The ID token
  */
  'idToken'?: string | null;
  /**
  * The refresh token
  */
  'refreshToken'?: string | null;
  /**
  * The token type
  */
  'tokenType'?: string | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "accessToken",
      "baseName": "accessToken",
      "type": "string",
      "format": ""
    },
    {
      "name": "expiresIn",
      "baseName": "expiresIn",
      "type": "number",
      "format": ""
    },
    {
      "name": "idToken",
      "baseName": "idToken",
      "type": "string",
      "format": ""
    },
    {
      "name": "refreshToken",
      "baseName": "refreshToken",
      "type": "string",
      "format": ""
    },
    {
      "name": "tokenType",
      "baseName": "tokenType",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AuthResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

